/* eslint-disable @typescript-eslint/no-non-null-assertion */

function initMobileMenu() {
	const menu = document.getElementById('mobileMenu');

	function toggleMobileMenu(event: Event) {
		if ((event.target as HTMLInputElement).checked) {
			menu!.classList.add('open');
			document.body.classList.add('max-h-full');
			document.body.classList.add('overflow-hidden');
		} else {
			menu!.classList.remove('open');
			document.body.classList.remove('max-h-full');
			document.body.classList.remove('overflow-hidden');
		}
	}

	const toggle = document.getElementById('mobileMenuToggle');
	toggle!.addEventListener('change', toggleMobileMenu);
}


export function initMenus() {
	initMobileMenu();
}